exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-size[data-v-393a930f]{font-size:21px}.tip-position[data-v-393a930f]{right:38px;z-index:1}.tip-position[data-v-393a930f]::after{content:'';width:0;height:0;right:-10px;top:calc(50% - 15px);border-top:15px solid transparent;border-bottom:15px solid transparent;border-left:15px solid #041D59;position:absolute;clear:both}\n", ""]);

// exports
